import { Grid, Stack, Typography } from "@mui/material";
import { ReactComponent as NoDownSvg } from "../../../assets/noDown.svg";
import { ReactComponent as NoDownGraySvg } from "../../../assets/noDown_Grau.svg";
import { ReactComponent as NoUpSvg } from "../../../assets/noUp.svg";
import { ReactComponent as NoUpDownSvg } from "../../../assets/noUpDown.svg";
import { ReactComponent as NoUpDownGraySvg } from "../../../assets/noUpDown_Grau.svg";
import { ReactComponent as NoUpGraySvg } from "../../../assets/noUp_Grau.svg";
import { HandheldLimitation } from "../../../cobra-backend-client";

interface Props {
  handheldLimitation: HandheldLimitation;
}

const HandheldLimitationComponent = (props: Props) => {
  return (
    <>
      <Grid
        item
        xs={6}
        sm={6}
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          display: "flex",
        }}
      >
        <Typography>Limitation </Typography>
      </Grid>
      <Grid item xs={6} sm={6}>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          {props.handheldLimitation.noUpDown ? (
            <NoUpDownSvg
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          ) : (
            <NoUpDownGraySvg
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          )}

          {props.handheldLimitation.noClose ? (
            <NoUpSvg
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          ) : (
            <NoUpGraySvg
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          )}

          {props.handheldLimitation.noOpen ? (
            <NoDownSvg
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          ) : (
            <NoDownGraySvg
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          )}
        </Stack>
      </Grid>
    </>
  );
};

export { HandheldLimitationComponent };
